export enum RegisterStatusEnum {
  REGISTERED = 1, // 申请通过
  PHONE_PASS = 2, // 手机认证通过
  FILLED_CITY_INFO = 3, // 已填写城市信息
  FILLED_ID_CARD = 4, // 已填写身份信息
  FILLED_CAR_INFO = 5, // 已填写车辆信息
  FILLED_OTHER = 6, // 已上传其他资料
  REJECT = 7, // 已驳回
  REFUSE = 8, // 已拒绝
  SUPPLEMENTED = 9, // 已补充
  DESTORY = 10, // 已注销
}

export enum FaceAuthStatusEnum {
  NOT_TRIGGERED = 0, // 未触发
  TO_BE_VERIFIED = 1, // 待验证
  VERIFICATION_FAILED = 2, // 验证不通过
  VERIFICATION_FAILED_MANY_TIMES = 3, // 验证不通过次数过多
  PASS = 4, // 验证通过
}

export enum YesOrNoEnum {
  NO = 0,
  YES = 1,
}

export enum PhotoTypeEnum {
  DRIVER_LICENSE = 1, // 驾驶证
  VEHICLE_BODY = 2, // 车身照
  ID_CARD = 4, // 身份证
  PROFILE_PICTURE = 5, // 形像照
  ID_CARD_BACK = 17, // 身份证背面
  DRIVING_LICENSE_FRONT = 18, // 行驶证正面
  DRIVING_LICENSE_BACK = 19, // 行驶证背面
  TRAFFIC_INSURANCE_POLICY = 30, // 交强险保单
  ONLINE_DRIVER_LICENSE = 40, // 网约车驾驶证
  ONLINE_TRANSPORT_LICENSE = 41, // 网约车运输证
  ONLINE_DRIVER_LICENSE_SUB = 43, // 网约车驾驶证补充说明
  VEHICLE_ANNUAL_INSPECTION_IMG = 44, // 车辆年检照片
}

export enum IdCardCheckEnum {
  WRONG_NUMBER = 2001009, // 身份证号格式有误
  PASS = 3001004, // 实名通过
  FAIL = 3001005, // 实名未通过
  OCCUPIED = 8040001, // 被占用
}

export enum CommercialTypeEnum {
  UNKNOW = 0,
  ONLINE_CAR = 1,
  TAXI = 2,
}

export enum SexEnum {
  MALE = 0,
  FEMALE = 1,
}

export enum RuleTypeEnum {
  AGE = '1', // 年龄
  DRIVER_AGE = '2', // 驾龄
  VEHICLE_AGE = '3', // 车龄
  VEHICLE_TYPE = '80001', // 车辆类型规则
}

export enum ErrorCodeEnum {
  CAR_NUMBER_REGISTERED = 20002, // 车牌号已被注册
}

export enum PhotoStatusEnum {
  TO_BE_UPLOAD = 0,
  CHECKING = 1,
  REJECT = 2,
  PART_PASS = 3,
  ALL_PASS = 4,
}

export enum UploadModelEnum {
  NORMAL = 0,
  REJECT = 3,
}

// 出车培训学习状态
export enum EduStatusEnum {
  NO_NEED_LEARN = 0, // 无需学
  NEED_LEARN = 1, // 需要学，还未开始学习（文案：开始出车培训）
  CONTINUE_LEARN = 2, // 需要学，还未完成学习（文案：继续培训学习）
  DONE = 3, // 完成学习
}

export enum FaceAccessCheckEnum {
  NONE = 0, // 无需人脸
  V2FACE = 1, // v2
  V3FACE = 2, // v3
}

export enum FaceCheckResultEnum {
  PASS = 0, // 0-通过，无需再次验证
  RETRY = 1, // 1-可以再次验证或初次拉起
  FAIL = 2, // 2-未通过，且验证结束不可再次验证，仅告知结果
}

export enum VehicleOwnershipEnum {
  COMPANY = 1,
  PERSONAL,
}

export enum UnbindVehicleStatusEnum {
  PENDDING = 1, // 待审核
  REJECT, // 驳回
  SUPPLEMENT, // 补充资料待审核
  SUCCESS, // 解绑成功
  FAIL, // 审核成功 解绑失败
  CANCEL, // 取消
}

// 1：未发起审核，2：审核不是自己，3：驳回，4：审核是自己，5 解绑失败, 6 重复提交
export enum InApplyStatusEnum {
  NOT_INIT = 1,
  AUDITING_NOT_SELF = 2,
  REJECT = 3,
  AUDITING_SELF = 4,
  UNBIND_FAIL = 5,
  DUPLICATE,
}

// 双证审核状态，0-去上传，1-继续上传，2-审核中
export enum OnlineCertificatesStatusEnum {
  TO_BE_UPLOAD,
  CONTINUE_UPLOADING,
  AUDITING,
}

// 协议类型 1-隐私政策 2-小拉准入 3-巨能装 4-顺风车合乘 5-顺风车司机隐私政策 6-巨能装隐私政策
export enum AgreementEnum {
  PRIVATE = 1,
  XL_JOIN,
  JNZ,
  SFC,
  SFC_PRIVATE,
  JNZ_PRIVATE,
}
